import Entity from '../entity'
export default class User extends Entity<number>{
    first_name:string;
    last_name:string;
    username:string;
    email:string;
    avatar_type:string;
    avatar_location:string;
    password:string;
    active: boolean;
    default_tab_id: number;
    function_id: number;
    phone: string;
    movil: string;
    dealers: number;
    roles: Array<any>;

    avatar_url: string;
}